import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IFinancePurchaseOrderListFilterBody,
  IFinancePurchaseOrderListResponse,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setFinancePurchaseOrderListAPI } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});

export const useFinancePurchaseOrderListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterProps?: IFinancePurchaseOrderListFilterBody, convertToCSV: boolean = false, po_number?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const baseURL = INVENTORY_MODULE?.FINANCE_PURCHASE_ORDER_LIST?.baseURL ?? "";
        const headers = {
          Authorization: `${accessToken}`,
          "Content-Type": "application/json",
        };
        if (po_number) {
          const url = `${baseURL}?po_number=${encodeURIComponent(po_number)}`;
          const response = await axios.post(url, {}, { headers });
          const data = response.data as IFinancePurchaseOrderListResponse;
          if (data.status === true) {
            dispatch(setFinancePurchaseOrderListAPI({ data: data.data }));
            return { status: true, message: "PO fetched successfully" };
          } else {
            dispatch(setFinancePurchaseOrderListAPI({ data: [] }));
            return { status: false, message: "No data found" };
          }
        }
        const url = convertToCSV ? `${baseURL}?convert_to_csv=1` : baseURL;
        const response = await axios.post(url, filterProps, {
          headers,
          responseType: convertToCSV ? "blob" : "json",
        });
        if (convertToCSV) {
          const blob = new Blob([response.data], { type: "text/csv" });
          const downloadUrl = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.download = "Finance_Purchase_Orders.csv";
          link.click();
          window.URL.revokeObjectURL(downloadUrl);
          return { status: true, message: "CSV exported successfully" };
        }
        const data = response.data as IFinancePurchaseOrderListResponse;
        if (data.status === true) {
          dispatch(setFinancePurchaseOrderListAPI({ data: data.data }));
          return { status: true, message: "List fetched successfully" };
        } else {
          dispatch(setFinancePurchaseOrderListAPI({ data: [] }));
          return { status: false, message: "No data found" };
        }
      } catch (e: any) {
        captureError(e);
        // toast.error("Server Error: " + e.message);
        sendCurl(e?.config?.curlCommand);
        dispatch(setFinancePurchaseOrderListAPI({ data: [] }));
        return { status: false, message: "Error fetching list" };
      }
    },
    [dispatch],
  );

  return execute;
};
